export function isSupported(storage: Storage): boolean {
  try {
    const testKey = '__tr_test___key__';
    storage.setItem(testKey, testKey);
    storage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}
